import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { ReactFC } from '../types'

export interface Transition {
    transitionName: string
    transitionDuration?: number
}

export interface PageTransitionProps extends Transition{
    id: string
}

export const PageTransitions: ReactFC<PageTransitionProps> = ({
    children, transitionName,
    transitionDuration, id
}) => {
    const timeout = transitionDuration || (transitionName ? 300 : 1)
    const classNames = transitionName

    return (
        <TransitionGroup
            component={null}
            childFactory={child => React.cloneElement(child, { classNames, timeout })}
        >
            <CSSTransition
                in={true}
                appear={true}
                key={id}
                timeout={timeout}
                classNames={classNames}
                className="animated-list"
            >
                {children}
            </CSSTransition>
        </TransitionGroup>
    )
}

export default PageTransitions